import React from "react";
import clsx from "clsx";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { LuSearch } from "react-icons/lu";

import useCrudListStyles from "./useCrudListStyles";
import useModernDialogStyles from "./useModernDialogStyles";
import {
  CRUD_ACTION_ICON_SIZE,
  CRUD_ACTION_ICON_STROKE,
} from "./constants";

export {
  CRUD_ACTION_ICON_SIZE,
  CRUD_ACTION_ICON_STROKE,
  useCrudListStyles,
  useModernDialogStyles,
};

export function CrudListPage({
  title,
  toolbar,
  children,
  onScroll,
  tableMinWidth = 560,
  toolbarWide = false,
  beforeContent = null,
}) {
  const classes = useCrudListStyles({ tableMinWidth });

  return (
    <div className={classes.pageRoot}>
      {beforeContent}
      <div className={classes.header}>
        <Typography component="h1" className={classes.pageTitle}>
          {title}
        </Typography>
        <div
          className={clsx(classes.toolbar, toolbarWide && classes.toolbarWide)}
        >
          {toolbar}
        </div>
      </div>
      <Paper className={classes.mainPaper} variant="outlined">
        <div className={classes.tableScroll} onScroll={onScroll}>
          {children}
        </div>
      </Paper>
    </div>
  );
}

export function CrudSearchField({
  value,
  onChange,
  placeholder,
  className,
  classes,
}) {
  const defaultClasses = useCrudListStyles({ tableMinWidth: 560 });
  const styles = classes || defaultClasses;

  return (
    <TextField
      className={clsx(styles.searchField, className)}
      placeholder={placeholder}
      type="search"
      size="small"
      variant="outlined"
      value={value}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <LuSearch
              size={18}
              strokeWidth={1.75}
              color="currentColor"
              aria-hidden
            />
          </InputAdornment>
        ),
      }}
    />
  );
}

export function CrudPageSizeSelect({
  value,
  onChange,
  label = "Itens/página",
  options = [20, 50, 100],
  classes,
}) {
  const defaultClasses = useCrudListStyles({ tableMinWidth: 560 });
  const styles = classes || defaultClasses;
  const labelId = "crud-page-size-label";

  return (
    <FormControl
      variant="outlined"
      size="small"
      className={styles.pageSizeSelect}
    >
      <InputLabel id={labelId} shrink>
        {label}
      </InputLabel>
      <Select
        labelId={labelId}
        value={value}
        onChange={onChange}
        label={label}
        notched
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export function CrudActionButton({
  icon: Icon,
  onClick,
  ariaLabel,
  disabled = false,
  danger = false,
  classes,
}) {
  const defaultClasses = useCrudListStyles({ tableMinWidth: 560 });
  const styles = classes || defaultClasses;

  return (
    <IconButton
      size="small"
      className={clsx(
        styles.actionButton,
        danger && styles.actionButtonDanger
      )}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <Icon
        size={CRUD_ACTION_ICON_SIZE}
        strokeWidth={CRUD_ACTION_ICON_STROKE}
        aria-hidden
      />
    </IconButton>
  );
}
